<template>
  <div>
    <a-modal
      width="640px"
      v-model="isShow"
      centered
      :mask-closable="false"
      title="编辑eSIM供应商"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <span>基本信息</span>

        <a-form-item label="名称">
          <a-input
            v-decorator="['name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入名称' },
                { max: 100, message: '最多100个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="联系人">
          <a-input
            v-decorator="['contact_name', {
              normalize: this.$lodash.trim,
              rules: [
                { max: 100, message: '最多100个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="联系人电话">
          <a-input
            v-decorator="['contact_phone', {
              normalize: this.$lodash.trim,
              rules: [
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="备注">
          <a-textarea
            v-decorator="['remark', {
              rules: [
                { max: 500, message: '最多500个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-divider />

        <span>登录信息</span>

        <a-form-item label="eSIM平台URL">
          <a-input
            v-decorator="['platform_url', {
              normalize: this.$lodash.trim,
              rules: [{ max: 200, message: '最多200个字符' }]
            }]"
          />
        </a-form-item>

        <a-form-item label="eSIM平台账号">
          <a-input
            v-decorator="['platform_account', {
              normalize: this.$lodash.trim,
              rules: [{ max: 50, message: '最多50个字符' }]
            }]"
          />
        </a-form-item>

        <a-form-item label="eSIM平台密码">
          <a-input
            v-decorator="['platform_password', {
              normalize: this.$lodash.trim,
              rules: [{ max: 50, message: '最多50个字符' }]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findEsimSupplierForm, updateEsimSupplier } from '@/api/esim_supplier'

export default {
  name: 'EditEsimSupplier',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'esim_supplier_edit' }),
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findEsimSupplierForm(this.id).then((res) => {
        if (res.code === 0) {
          this.form.setFieldsValue(res.data)
        }
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateEsimSupplier(this.id, values).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
